import type {BallotStatus} from '../../shared/ballotTypes';

export type VoteAction = 'edit' | 'present' | 'reveal' | 'results' | 'duplicate' | 'delete';

const BY_STATUS: Record<BallotStatus, VoteAction[]> = {
    draft: ['edit', 'present', 'duplicate', 'delete'],
    open: ['present'],
    closed: ['reveal', 'duplicate', 'delete'],
    revealed: ['results', 'duplicate', 'delete'],
};

export const actionsFor = (status: BallotStatus, _revealStep: number): VoteAction[] =>
    BY_STATUS[status];
